import { useEffect, useState, useRef } from "react";
import { getImageUrl } from '../firebase/storageService';
import { authFetch } from "../utils/authFetch";

const Aniversariantesdomes = () => {
  const [aniversariantes, setAniversariantes] = useState([]);
  const [mesSelecionado, setMesSelecionado] = useState(new Date().getMonth() + 1); // 1-12
  const abortController = useRef(null);

  useEffect(() => {
    // Create a new AbortController for this cycle
    abortController.current = new AbortController();

    const fetchAniversariantes = async () => {
      try {
        const response = await authFetch(`dashboard/birthdays/month/${mesSelecionado}`, {
          signal: abortController.current.signal
        });

        if (!response.ok) {
          throw new Error("Erro ao buscar Aniversariantes");
        }

        const data = await response.json();

        const aniversariantesComImagem = await Promise.all(
          data.map(async (aniversariante) => {
            try {
              const url =
                aniversariante.type === "T"
                  ? await getImageUrl('therapist', aniversariante.id, abortController.current.signal)
                  : await getImageUrl('patient', aniversariante.id, abortController.current.signal);
              return { ...aniversariante, imageUrl: url };
            } catch (err) {
              if (err.name === 'AbortError') return { ...aniversariante, imageUrl: null };
              return { ...aniversariante, imageUrl: null };
            }
          })
        );

        setAniversariantes(aniversariantesComImagem);
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') return;
        console.error("Erro ao carregar aniversariantes", error);
      }
    };

    fetchAniversariantes();

    // Cleanup: abort the request when component unmounts
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, [mesSelecionado]);

  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];

  return (
    <div className="col-lg-6 mb-lg-0 mb-4">
      <div className="card card-dashboard-20" style={{ borderRadius: '12px' }}>
        <div className="card-header pb-0 d-flex justify-content-between align-items-start">
          <h6 className="mb-2 font-weight-bolder" style={{ marginBottom: '0.75rem' }}>Aniversariantes do Mês</h6>
          <div style={{ minWidth: '120px' }}>
            <label className="form-label text-sm mb-1">Mês:</label>
            <select
              className="form-control form-control-sm"
              value={mesSelecionado}
              onChange={(e) => setMesSelecionado(Number(e.target.value))}
            >
              {meses.map((m, i) => (
                <option key={i + 1} value={i + 1}>{m}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="card-body px-0 pb-2">
          <div className="table-responsive">
            <table className="table align-items-center mb-0">
              <thead>
                <tr>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Aniversariante</th>
                  <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Data</th>
                </tr>
              </thead>
              <tbody>
                {aniversariantes.map((a, idx) => (
                  <tr key={idx}>
                    <td className="text-xs mb-0">
                      <div className="d-flex px-2 py-1">
                        <div>
                          <img
                            src={a.imageUrl || require('../assets/img/perfilvazio.png')}
                            alt="foto-aniversariante"
                            className="avatar avatar-sm me-3"
                            style={{ borderRadius: "1.75em" }}
                          />
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-sm" style={{ fontSize: '1.26rem' }}>{a.name}</p>
                        </div>
                      </div>
                    </td>
                    <td className="text-xs mb-0">
                      <div className="d-flex px-2 py-1">
                        <div className="d-flex flex-column justify-content-center">
                          <i
                            className="fa-solid fa-cake-candles text-primary text-gradient"
                            style={{ marginRight: "3px" }}
                          ></i>
                        </div>
                        <div className="d-flex flex-column justify-content-center">
                          <p className="mb-0 text-sm" style={{ fontSize: '1.26rem' }}>
                            {new Date(a?.date).toLocaleDateString("pt-BR", {
                              day: "2-digit",
                              month: "2-digit",
                              timeZone: "UTC"
                            })
                            }
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
                {aniversariantes.length === 0 && (
                  <tr>
                    <td colSpan={2} className="text-center text-sm py-3">Nenhum aniversariante neste mês</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aniversariantesdomes;
